<template>
  <IQOS
    :title="$t('inside.stickers.title')"
    :class="entering_info ? 'iqos iqos-long':'iqos-stickers iqos-long'"
    boxClass="container-box p-30"
  >
    <div v-if="!entering_info" class="d-flex">
      <img :src="templateSrc" class="template-preview" />
      <div class="template-settings">
        <div v-if="!shipment">
          <p class="order-comment c-white">{{$t('inside.stickers.about')}}</p>
          <CircleToggle
            class="template-button"
            v-for="template in templates"
            :key="template"
            :value="selected_template == template"
            @input="selectTemplate(template)"
          >{{ template | capitalize}}</CircleToggle>
          <!-- <p class="order-comment c-white comment">
            {{ $t('inside.stickers.choose_language') }}
          </p>
          <div>
            <CircleToggle
              class="iqos-group-item"
              :value="selected_language == 'ua'"
              @input="v => selected_language = 'ua'"
            >Українська</CircleToggle>
            <CircleToggle
              class="iqos-group-item"
              :value="selected_language == 'ru'"
              @input="v => selected_language = 'ru'"
            >Русский</CircleToggle>
            <CircleToggle
              class="iqos-group-item"
              :value="selected_language == 'en'"
              @input="v => selected_language = 'en'"
            >English</CircleToggle>
          </div> -->
          <div v-if="in_lite">
            <p class="comment c-white">
              Вкажіть, скільки стікерів INSIDE lite Ви бажаєте отримати:
              <BaseInput
                class="iqos-group-item"
                type="number"
                placeholder="10"
                v-model="inside_lite_count"
                :readonly="false"
              />
            </p>
          </div>
          <div class="iqos-group-item" v-if="in_lite">
            <a :href="insideLiteLink">
              <button
                class="square-button change-order-button"
              >{{ $t('inside.stickers.download_lite') }}</button>
            </a>
          </div>
        </div>

        <div v-if="!shipment">
          <DashboardButton
            wide
            @click="firstOrder"
            :disabled="totalStickers == 0"
            class="iqos-group-item"
          >
            {{$t('inside.stickers.order')}} {{isFirstOrder ? '' : $t('inside.stickers.again')}}
            <span
              v-if="totalStickers"
            >({{totalStickers}} {{$t('inside.stickers.amount')}})</span>
          </DashboardButton>
        </div>
        <p class="comment c-red" v-if="totalTables == 0">{{ $t('inside.stickers.no_sections') }}</p>
        <div v-if="shipment">
          <p class="comment c-white pt-0">
            {{ $t('inside.stickers.order_accepted', {
              date: shipmentDateFormatted,
              template: shipment.type.substring(0,1).toUpperCase() + shipment.type.substring(1)
            }) }}
          </p>

          <button class="square-button change-order-button iqos-goup-item" disabled>
            <span
              v-if="shipment.status == 'waiting'"
            >{{$t('inside.stickers.order_created')}} {{shipment.created_at | formatDate}}</span>
            <span
              class="c-yellow"
              v-if="shipment.status == 'preparing'"
            >{{$t('inside.stickers.in_print')}}</span>
            <span
              class="c-green"
              v-if="shipment.status == 'shipping'"
            >{{$t('inside.stickers.is_sent')}}</span>
          </button>

           <p class="comment c-white novaposhta-status" v-if="shipment.novaposhta_ttn">
            <img src="/icons/novaposhta.png" class="novaposta-icon" />
            ТТН:
            <b>{{ shipment.novaposhta_ttn }}</b>
            <span v-if="novaposhta_status">({{ novaposhta_status }})</span>
          </p>
        </div>
        <div v-if="totalTables > 0 && !shipment">
          <p
            class="order-time c-grey"
            v-if="selected_quality || (shipment && shipment.is_quality)"
          >{{$t('inside.stickers.wait_wide')}}</p>
          <p class="order-time c-grey" v-else>{{$t('inside.stickers.wait_digital')}}</p>
        </div>
      </div>
    </div>
    <div v-if="entering_info" class="w-54">
      <div class="row">
        <div class="col">
          <p class="comment c-white pt-0">{{ $t('inside.stickers.contacts') }}</p>
          <BaseInput
            v-model="form_details.name"
            :class="{
              'iqos-group-item': true,
              'invalid-input': info_invalid && !form_details.name
            }"
            :placeholder="$t('inside.stickers.name_ph')"
            :readonly="false"
          />
          <BaseInput
            v-model="form_details.phone"
            :class="{
              'iqos-group-item': true,
              'invalid-input': info_invalid && !form_details.phone
            }"
            :placeholder="$t('inside.stickers.phone_ph')"
            :readonly="false"
          />

          <BaseInput
            v-model="form_details.comment"
            class="iqos-group-item"
            :placeholder="$t('inside.stickers.comment_ph')"
            :readonly="false"
          />
        </div>
        <div class="col">
          <p class="comment c-white pt-0">{{$t('inside.stickers.delivery_way')}}</p>
          <CircleToggle
            class="iqos-group-item"
            :value="!by_courier"
            @input="by_courier = false"
            v-if="isNovaPoshtaAvailable"
          >{{ $t('inside.stickers.by_novaposhta') }}</CircleToggle>
          <BlackSelect
            :class="{
              'iqos-group-item': true,
              'invalid-input': info_invalid && !form_details.warehouse
            }"
            v-model="form_details.warehouse"
            v-if="!by_courier && isNovaPoshtaAvailable"
          >
            <option :value="null" disabled>Оберіть відділеня Нової Пошти</option>
            <option
              :value="warehouse.Description"
              v-for="warehouse in warehouses"
              :key="warehouse.Ref"
            >{{ warehouse.Description}}</option>
          </BlackSelect>
          <CircleToggle
            class="iqos-group-item"
            :value="by_courier"
            @input="by_courier = true"
          >{{ $t('inside.stickers.by_courier') }}</CircleToggle>
          <BaseInput
            v-model="form_details.address"
            :class="{
              'iqos-group-item': true,
              'invalid-input': info_invalid && !form_details.address
            }"
            :placeholder="$t('inside.stickers.address_ph')"
            :readonly="false"
            v-if="by_courier"
          />
          <p class="comment c-white pt-0 iqos-group-item">
            {{ $t('inside.stickers.price') }}: {{ totalPrice }} грн.
            <DashboardButton
              class="w-100 iqos-group-item"
              @click="sendOrder"
            >{{ $t('inside.stickers.order_button') }}</DashboardButton>
          </p>
        </div>
      </div>
      <form
        id="shipmentPaymentForm"
        method="POST"
        action="https://www.liqpay.ua/api/3/checkout"
        accept-charset="utf-8"
      >
        <input type="hidden" name="data" :value="pay_form.data" />
        <input type="hidden" name="signature" :value="pay_form.signature" />
      </form>
    </div>

    <DashboardButton
      class="back-to-templates"
      variant="danger"
      @click="entering_info = false"
      v-if="entering_info"
    >{{ $t('inside.stickers.return') }}</DashboardButton>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import CircleToggle from "@/components/CircleToggle.vue";
import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

import DashboardButton from "@/components/DashboardButton.vue";

import ShipmentAPI from "@/api/shipment";

import moment from 'moment'

export default {
  data() {
    return {
      selected_template: "basic",
      templates: ["basic", "classic", "hype"],
      selected_quality: true,
      entering_info: false,
      form_details: {
        name: null,
        phone: null,
        address: null,
        comment: null,
        warehouse: null,
      },
      selected_language: "ua",
      warehouses: [],
      shipment: null,
      by_courier: true,

      info_invalid: false,

      inside_lite_count: null,

      pay_form: {},

      novaposhta_status: null,
    };
  },
  props: {
    in_lite: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectTemplate(template) {
      this.selected_template = template;
    },
    fetchWarehouses() {
      ShipmentAPI.getWarehouses(this.cafe.city)
        .then((data) => {
          this.warehouses = data.list;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "warehouses_error");
        });
    },
    fetchDeliveryStatus() {
      if (!this.shipment || !this.shipment.novaposhta_ttn) return;

      ShipmentAPI.getDeliveryStatus(this.shipment.novaposhta_ttn)
        .then((data) => {
          this.novaposhta_status = data.tracking.Status;
        })
        .catch((error) => {});
    },
    firstOrder() {
      //Fill some details about user
      this.form_details.name = this.owner.name;
      this.form_details.phone = this.cafe.contact_phone || this.owner.phone;

      // if (!this.requireWarehouse) {
      //   //if the cafe is in the same town as QRWaiter
      //   //fill the address and don't show it in the form
      //   this.form_details.warehouse =
      //     this.cafe.address || "Не вказана адреса закладу";

      //   if (this.isOrderFree) {
      //     this.sendOrder();
      //   } else {
      //     this.entering_info = true;
      //   }
      //   return;
      // }

      this.entering_info = true;
    },
    sendOrder() {
      if (!this.form_details.name || !this.form_details.phone) {
        this.info_invalid = true;
        return;
      }

      if (!this.by_courier && !this.form_details.warehouse) {
        this.info_invalid = true;
        return;
      }

      if (this.by_courier && !this.form_details.address) {
        this.info_invalid = true;
        return;
      }

      this.info_invalid = false;

      if (this.by_courier) this.form_details.warehouse = null;
      ShipmentAPI.putOrder({
        recipient: this.form_details.name,
        phone: this.form_details.phone,
        type: this.selected_template,
        address: this.form_details.address,
        comment: this.form_details.comment,
        warehouse: this.form_details.warehouse,
        count: this.totalStickers,
        system: this.in_lite ? "inside_lite" : "inside",
        language: this.selected_language,
      })
        .then((data) => {
          this.shipment = data.shipment;
          this.pay_form = data.form;

          this.$nextTick(() => {
            document.getElementById("shipmentPaymentForm").submit();
          });
          // this.entering_info = false;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "shipment_failed");
        });
    },
    fetchShipment() {
      ShipmentAPI.query(this.cafe._id)
        .then((data) => {
          this.shipment = data.shipment;

          this.fetchDeliveryStatus();
        })
        .catch((error) => {
          this.$store.dispatch("showError", "shipment_failed");
        });
    },
  },
  mounted() {
    this.fetchShipment();
    this.fetchWarehouses();

    if (this.owner.phone) {
      this.form_details.phone = this.owner.phone;
    }

    if (!this.isNovaPoshtaAvailable) {
      this.by_courier = true;
    }

    this.selected_language = this.owner.language;
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    owner() {
      return this.$store.state.owner;
    },
    submitButtonClass() {
      return {
        "confirm-green-button": true,
        "form-submit": true,
      };
    },
    formValid() {
      if (!this.form_details.name || this.form_details.name.length < 3)
        return false;
      if (!this.form_details.phone || this.form_details.phone.length < 7)
        return false;
      if (!this.form_details.warehouse && !this.form_details.address)
        return false;

      return true;
    },
    totalTables() {
      return this.cafe.sections.reduce(
        (acc, section) => acc + section.tables,
        0
      );
    },
    totalStickers() {
      if (this.in_lite) return this.inside_lite_count;
      return this.totalTables * this.stickersPerTable;
    },
    stickersPerTable() {
      return 3;
    },
    totalPrice() {
      const MINIMAL_PRICE = 380;

      if (this.isOrderFree) {
        return 0;
      }

      if (!this.selected_quality) {
        const LOW_QUALITY_STICKER_PRICE = 5;
        return this.totalStickers * LOW_QUALITY_STICKER_PRICE;
      }

      const QUALITY_STICKER_PRICE = 10;

      const final_price = Math.ceil(this.totalStickers * QUALITY_STICKER_PRICE);

      return Math.max(MINIMAL_PRICE, final_price);
    },
    requireWarehouse() {
      return this.cafe.city != "Ужгород";
    },
    isFirstOrder() {
      return !this.cafe.activated;
    },
    isOrderFree() {
      return !this.cafe.activated && !this.selected_quality;
    },
    templateSrc() {
      // const country = this.$store.state.owner.country.toLowerCase();

      // const sticker_locale = ['ua', 'ru'].includes(country) ? country : 'en';
      const sticker_locale = this.selected_language || 'ua';

      const sticker_type = this.shipment ? this.shipment.type : this.selected_template;

      return `/api/shipment/preview/${this.cafe._id}?locale=${sticker_locale}&type=${sticker_type}`;
    },
    insideLiteLink() {
      return `/api/shipment/inside_lite_sticker?template=${
        this.selected_template
      }&code=${
        this.cafe.inside_lite_id
      }&language=${this.owner.country.toLowerCase()}`;
    },
    isNovaPoshtaAvailable() {
      return this.$store.getters["worldwide/checkService"]("novaposhta");
    },
    shipmentDateFormatted() {
      if (!this.shipment) return '';

      return moment(this.shipment.created_at).format('DD.MM.YYYY');
    }
  },
  filters: {
    capitalize(v) {
      return v.substring(0, 1).toUpperCase() + v.substring(1);
    },
  },
  components: {
    IQOS,
    CircleToggle,
    BlackInput,
    BlackSelect,
    RoundCheckbox,
    DashboardButton,
  },
};
</script>

<style scoped>
.w-50 {
  width: 52vh !important;
}

.w-55 {
  width: 55vh !important;
}

.container-box.p-30 {
  padding: 3.3vh !important;
}

.order-comment {
  margin: 1vh 0 0;
  font-size: 1.7vh;
}

.total-price {
  width: 15vh;
}

.info-delivery h4 {
  padding-top: 2.5vh;
  font-size: 2.7vh;
}

.info-form h4 {
  font-size: 2.3vh;
}

.info-total h4 {
  font-size: 2.7vh;
}

.info-delivery p {
  font-size: 1.7vh;
}

.template-button {
  margin-top: 1.3vh;
}

.order-button {
  margin-top: 1vh;
}

.order-time {
  text-align: center;
  font-size: 1.3vh;
  margin-top: 1.2vh;
  margin-bottom: 0;
}

.info-total {
  display: flex;
  justify-content: space-between;
}

.info-form {
  padding-top: 3.3vh;
  color: #ededed;
}

.info-input {
  width: 100%;
}

.warehouse-input {
  /* font-size: 2vh; */
  width: 100%;
}

.form-label {
  margin-top: 2.2vh;
}

.form-submit {
  margin-top: 2vh;
}

.change-order-button {
  width: 100%;
}

.quality-button {
  margin-top: 1.5vh;
}

.payment-block {
  display: flex;
  margin-top: 2vh;
  justify-content: space-between;
}

.payment-block img {
  margin-top: 1vh;
  width: 5vh;
}

.template-preview {
  width: 45vh;
  height: 45vh;
  margin-left: 5vh;
}

.template-settings {
  margin-left: auto;
  width: 54vh;
}

.back-button {
  width: 100%;
}

.back-to-templates {
  position: absolute;
  top: 1.3vh;
  right: 2.3vh;
}

.invalid-input {
  border: 2px solid #e2223b;
}

.novaposta-icon {
  width: 3vh;
  height: auto;
  display: inline-block;
  margin-right: 1vh;
}

.novaposhta-status {
  display: flex;
  align-content: center;
  align-items: center;
}

.novaposhta-status b {
  margin: 0 0.5vh;
}
</style>